import { whiteColor, headerBorderColor } from 'assets/jss/material-dashboard-pro-react';

const pageHeaderStyle = (theme) => ({
	logo: {
		flex: 'initial',
		[theme.breakpoints.down('md')]: {
			flex: 1,
			textAlign: 'center',
		},
	},
	menu: {
		flex: 1,
	},
	header: {
		backgroundColor: whiteColor,
		width: '100%',
		borderBottom: `1px solid ${headerBorderColor}`,
		position: 'sticky',
		top: 0,
		zIndex: 999,
		'& nav': {
			[theme.breakpoints.up('md')]: {
				paddingTop: '1rem',
			},
		},
	},
});

export default pageHeaderStyle;
